module.exports = __webpack_public_path__ + "img/safari-pinned-tab.2ad6e00b.svg";